import AppConstant from "../assets/js/AppConstant";
import { UserType } from "../assets/js/AppUserProfile";

const access = {
  Dealer: {
    parent: "RDOP",
    link: AppConstant.RDOP_URL,
  },
  Rever: {
    parent: "RMOS",
    link: AppConstant.RMOS_URL,
  },
};

export const EntryPoints = {
  [UserType.DEALER_BYD]: access.Dealer,
  [UserType.DEALER_DENZA]: access.Dealer,
  [UserType.REVER]: access.Rever,
  [UserType.ADMIN]: access.Rever,
  [UserType.ACCOUNTANT]: access.Rever,
  [UserType.BUSINESS_CONTROL]: access.Rever,
};
